export const getOfficeReceivedStatus = ({ officeUsers }) => {
  if (!officeUsers) {
    return null
  }

  const statuses = officeUsers.map((user) => user.receivedStatus)

  if (!statuses.length) {
    return null
  }

  if (statuses.some((x) => x === 'Completed')) {
    return 'Completed'
  }

  if (statuses.some((x) => x === 'Expired')) {
    return 'Expired'
  }

  if (statuses.some((x) => x === 'Pending Sender')) {
    return 'In Progress'
  }

  if (statuses[0] === 'New' && statuses.every((val, i, arr) => val === arr[0])) {
    return 'New'
  }

  if (statuses[0] === 'Declined' && statuses.every((val, i, arr) => val === arr[0])) {
    return 'Declined'
  }

  return 'Open'
}
